import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "formField-label" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
import { computed, ref } from 'vue';
import InputText from './InputText.vue';
import InputPassword from './InputPassword.vue';
import InputCheckbox from './InputCheckbox.vue';
import InputRadio from './InputRadio.vue';
//import InputGrade from './InputGrade.vue';
import InputChoiceMultiple from './InputChoiceMultiple.vue';
import InputChoiceSingle from './InputChoiceSingle.vue';
import InputTextarea from './InputTextarea.vue';
//import InputTextMask from './InputTextMask.vue';
import InputSelectCustom from './InputSelectCustom.vue';
import InputSelect from './InputSelect.vue';
const __default__ = {
    inheritAttrs: false,
};
export default /*@__PURE__*/ _defineComponent(Object.assign(Object.assign({}, __default__), { __name: 'FormField', props: {
        type: {},
        label: {},
        description: {},
        modelValue: {},
        required: { type: Boolean },
        error: {},
        warning: {},
        mask: {},
        containerClass: {}
    }, setup(__props, { expose: __expose }) {
        const props = __props;
        const type = props.type || 'text';
        const inputInst = ref(null);
        const cssClasses = computed(() => {
            const classes = {
                [`type--${type}`]: true,
                'is--required': props.required,
                'is--invalid': props.error,
                'has--value': hasValue(),
            };
            if (props.containerClass) {
                classes[props.containerClass] = true;
            }
            return classes;
        });
        __expose({
            focus: () => {
                var _a;
                if (typeof ((_a = inputInst.value) === null || _a === void 0 ? void 0 : _a.focus) === 'function') {
                    inputInst.value.focus();
                }
            },
        });
        function hasValue() {
            if (!props.modelValue) {
                return false;
            }
            if (typeof props.modelValue === 'object') {
                return Object.keys(props.modelValue).length > 0;
            }
            return true;
        }
        function resolveInputComponent() {
            switch (type) {
                case 'checkbox':
                    return InputCheckbox;
                case 'radio':
                    return InputRadio;
                case 'password':
                    return InputPassword;
                //case 'grade':
                //    return InputGrade;
                case 'choice-multiple':
                    return InputChoiceMultiple;
                case 'choice-single':
                    return InputChoiceSingle;
                case 'select-custom':
                    return InputSelectCustom;
                case 'select':
                    return InputSelect;
                case 'textarea':
                    return InputTextarea;
                default:
                    //if (props.mask) {
                    //    return InputTextMask;
                    //} else {
                    return InputText;
                //}
            }
        }
        function resolveWrapperTag() {
            switch (type) {
                case 'choice-multiple':
                case 'choice-single':
                case 'grade':
                    return 'div';
                default:
                    return 'label';
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(resolveWrapperTag()), {
                class: _normalizeClass(["formField", cssClasses.value])
            }, {
                default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(resolveInputComponent()), _mergeProps({
                        type: _unref(type),
                        class: "formInput",
                        modelValue: _ctx.modelValue,
                        required: _ctx.required
                    }, _ctx.$attrs, {
                        mask: _ctx.mask,
                        ref_key: "inputInst",
                        ref: inputInst,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', $event)))
                    }), null, 16, ["type", "modelValue", "required", "mask"])),
                    _createElementVNode("span", _hoisted_1, [
                        _createElementVNode("span", {
                            innerHTML: props.label
                        }, null, 8, _hoisted_2),
                        (props.required)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[1] || (_cache[1] = _createTextVNode(" ")),
                                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "formField-asterisk" }, "*", -1))
                            ], 64))
                            : _createCommentVNode("", true)
                    ]),
                    (props.error)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "formField-error",
                            innerHTML: props.error
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true),
                    (props.warning)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "formField-warning",
                            innerHTML: props.warning
                        }, null, 8, _hoisted_4))
                        : _createCommentVNode("", true),
                    (props.description)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: "formField-description",
                            innerHTML: props.description
                        }, null, 8, _hoisted_5))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["class"]));
        };
    } }));
